export default __webpack_public_path__ + "img/fixing.d63d2e8e.svg";